import { periodKeyToTaxYearLabel } from '@/helpers/periodDisplay'

/** Suggested download filename for a statement PDF. */
export function taxPackFilename(period: string): string {
  const label = periodKeyToTaxYearLabel(period).replace(/\s/g, '')
  return `Swiftaid-Statement-${label}.pdf`
}
